import { exposureStatusCheck, textFormat, upDataAtFormat } from "@utils/TableItemFormattingUtils";
import { type ColDef } from "ag-grid-community";
import { V2BannerCreateRequestDtoLinkType as LinkType } from "@everon-it/api-client/contents-gw";

export type ColumnDefs = {
    [LinkType.NOTICE]: ColDef[];
    [LinkType.EVENT]: ColDef[];
};

export const columnDefs: ColumnDefs = {
    [LinkType.NOTICE]: [
        {
            field: "isSelect",
            headerName: "선택",
            maxWidth: 62,
            flex: 1,
            suppressMovable: true,
            suppressSizeToFit: true,
        },
        {
            field: "isVisible",
            headerName: "노출 상태",
            maxWidth: 120,
            flex: 1,
            cellRenderer: exposureStatusCheck,
            suppressMovable: true,
        },
        {
            field: "publishDuration",
            headerName: "게시 기간",
            flex: 1,
            cellRenderer: textFormat,
            suppressMovable: true,
        },
        {
            field: "title",
            headerName: "제목",
            flex: 1,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
        {
            field: "updatedAt",
            headerName: "업데이트 일시",
            flex: 1,
            suppressMovable: true,
            cellRenderer: upDataAtFormat,
        },
    ],
    [LinkType.EVENT]: [
        {
            field: "isSelect",
            headerName: "선택",
            maxWidth: 62,
            flex: 1,
            suppressMovable: true,
            suppressSizeToFit: true,
        },
        {
            field: "isVisible",
            headerName: "노출 상태",
            maxWidth: 120,
            flex: 1,
            cellRenderer: exposureStatusCheck,
            suppressMovable: true,
        },
        {
            field: "publishDuration",
            headerName: "게시 기간",
            flex: 1,
            cellRenderer: textFormat,
            suppressMovable: true,
        },
        {
            field: "title",
            headerName: "제목",
            flex: 1,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
        {
            field: "updatedAt",
            headerName: "업데이트 일시",
            flex: 1,
            suppressMovable: true,
            cellRenderer: upDataAtFormat,
        },
    ],
};
